export const MAIN = 1;
export const ADDITIONAL = 2;
export const OVERTIME = 3;
export const CURRENT_GAME = 4;
export const FOULS = 5;
export const POSSESSION = 6;
export const INFO = 7;
export const PERIOD_INFO = 8;


// WEBPACK FOOTER //
// ./js/constants/MatchScore.js